<template>
  <div class="form-panel">
    <div class="form-panel__header">
      <h2 class="titulo-h2">¡Empieza Ahora!</h2>
    </div>
    <div class="form-panel__body">
      <div class="form-fields form-fields-invertido">
        <div class="form-fields__secundario">
          <img class="img-home-banner" :src="imagen" />
        </div>
      </div>
      <div class="form-fields form-fields-invertido">
        <div class="form-fields__secundario">
          <h2 class="titulo-h3">Regístrate con Facebook</h2>
          <div class="form-fields__secundario-botones">
            <router-link
              class="m-btn-icon m-btn-icon-facebook waves-effect waves-light"
              :to="{ name: 'facebook-login-url' }"
            />
            <!-- <a class="m-btn-icon m-btn-icon-google waves-effect waves-light" tabindex="0"/> -->
          </div>
        </div>
        <div class="form-fields__links">
          <router-link class="form-fields__links-link" :to="{ name: 'login' }"
            >¿Ya tienes una cuenta? Ingresa.</router-link
          >
        </div>
        <div class="form-fields__principal">
          <h2 class="titulo-h3-light">
            O crea una cuenta con tu correo electrónico
          </h2>
          <form class="form" action="">
            <div
              class="form__group"
              :class="{
                'form__group-invalid': $v.form.email.$error,
                'form__group-valid': !$v.form.email.$invalid,
              }"
            >
              <i class="icon-field icon-field-email"></i>
              <label for="email">Email</label>
              <input
                id="email"
                type="email"
                @blur="$v.form.email.$touch()"
                v-model="form.email"
              />
              <div class="form__group-validation" v-if="$v.form.email.$dirty">
                <p v-if="!$v.form.email.required">
                  Debes especificar un correo.
                </p>
                <p v-if="!$v.form.email.email">
                  El formato de correo no es válido.
                </p>
              </div>
            </div>

            <div
              class="form__group"
              :class="{
                'form__group-invalid': $v.form.IdTipoDocumento.$error,
                'form__group-valid': !$v.form.IdTipoDocumento.$invalid,
              }"
            >
              <i class="icon-field icon-field-arrow"></i>
              <label for="idTiposDocumento">Tipo de Documento</label>
              <v-select
                class="selectField"
                :items="tiposDocumento"
                v-model="form.IdTipoDocumento"
                item-text="descripcion"
                item-value="idTiposDocumento"
                change=""
                label="Seleccione su tipo de documento"
                solo
              ></v-select>
              <div
                class="form__group-validation"
                v-if="$v.form.IdTipoDocumento.$dirty"
              >
                <p v-if="!$v.form.IdTipoDocumento.minValue">
                  Debes especificar un tipo de documento.
                </p>
              </div>
            </div>

            <div
              class="form__group"
              :class="{
                'form__group-invalid': $v.form.documento.$error,
                'form__group-valid': !$v.form.documento.$invalid,
              }"
            >
              <i class="icon-field icon-field-arrow"></i>
              <label for="email">Documento</label>
              <input
                id="documento"
                type="text"
                @blur="$v.form.documento.$touch()"
                v-model="form.documento"
              />
              <div
                class="form__group-validation"
                v-if="$v.form.documento.$dirty"
              >
                <p v-if="!$v.form.documento.required">
                  Debes especificar un documento.
                </p>
                <!-- <p v-if="!$v.form.documento.SoloNumeros">
                  Debes ingresar solo números.
                </p> -->
                <!-- <p v-else-if="!$v.form.documento2.letrasNumeros && form.IdTipoDocumento == 3">
                  Debes ingresar solo números y letras.
                </p>
                <p v-if="!$v.form.documento.required && form.IdTipoDocumento == 3">
                  Debes especificar un documento.
                </p> -->
              </div>
            </div>

            <!-- <div
              class="form__group"
              :class="{
                'form__group-invalid': $v.form.documento2.$error,
                'form__group-valid': !$v.form.documento2.$invalid,
              }"
              v-else
            >
              <i class="icon-field icon-field-arrow"></i>
              <label for="email">Documento</label>
              <input
                id="documento2"
                type="text"
                @blur="$v.form.documento2.$touch()"
                v-model="form.documento2"
              />
              <div
                class="form__group-validation"
                v-if="$v.form.documento2.$dirty"
              >
                <p v-if="!$v.form.documento2.requiredIf">
                  Debes especificar un documento.
                </p>
                <p v-if="!$v.form.documento.SoloNumeros">
                  Debes ingresar solo números.
                </p>
                <p v-else-if="!$v.form.documento2.letrasNumeros">
                  Debes ingresar solo números y letras.
                </p>
                <p v-if="!$v.form.documento.required && form.IdTipoDocumento == 3">
                  Debes especificar un documento.
                </p>
              </div>
            </div> -->

            <div
              class="form__group"
              :class="{
                'form__group-invalid': $v.form.aceptarTerminos.$error,
                'form__group-valid':
                  form.aceptarTerminos == true &&
                  !$v.form.aceptarTerminos.$invalid,
              }"
              
            >
              <i class="icon-field icon-field-checked"></i>
              <label for="aceptarTerminos">He leído y acepto.</label>
              <div class="seleccionar">
                <v-switch
                  v-model="form.aceptarTerminos"
                  color="white"
                  class="seleccionar-control"
                />
                <a
                  href="https://www.lacentral.com.co/politicas/autorizacion-para-el-tratamiento-de-datos-personales/"
                  target="_blank"
                  class="seleccionar-etiqueta"
                  >Leer autorización tratamiento de datos.</a
                >
              </div>
              <div
                class="form__group-validation"
                v-if="$v.form.aceptarTerminos.$dirty"
              >
                <p v-if="!$v.form.aceptarTerminos.required">
                  Debes aceptar los términos.
                </p>
              </div>
            </div>
            <!-- <div
              class="form__group"
              :class="{
                'form__group-invalid': $v.form.aceptarTerminos.$error,
                'form__group-valid':
                  form.aceptarTerminos == true &&
                  !$v.form.aceptarTerminos.$invalid,
              }"
            >
              <i class="icon-field icon-field-checked"></i>
              <label for="aceptarTerminos">He leído y Acepto.</label>
              <div class="seleccionar">
                <v-switch
                  v-model="form.aceptarTerminos"
                  color="white"
                  class="seleccionar-control"
                >
                </v-switch>
                <a
                  href="https://www.lacentral.com.co/politicas/autorizacion-para-el-tratamiento-de-datos-personales/"
                  target="_blank"
                  class="seleccionar-etiqueta"
                  >Leer Autorización tratamiento de datos.</a
                >
              </div>

              <div
                class="form__group-validation"
                v-if="$v.form.aceptarTerminos.$dirty"
              >
                <p v-if="!$v.form.aceptarTerminos.required">
                  Debes aceptar los términos.
                </p>
              </div>
            </div> -->
            <div class="form__group form__group-register">
              <a
                class="waves-effect waves-light m-btn"
                tabindex="0"
                @click="$v.form.$invalid ? $v.form.$touch() : registrar()"
                @keyup.enter="$v.form.$invalid ? $v.form.$touch() : registrar()"
              >
                Registrarse</a
              >
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  required,
  email,
  minLength,
  numeric,
  minValue,
  sameAs,
  requiredIf,
} from "vuelidate/lib/validators";

const letrasNumeros = (value) => {
  if (typeof value === "undefined" || value === null || value === "") {
    return true;
  }
  return /^[A-Za-z0-9]+$/.test(value);
};
const SoloNumeros = (value) => {
  if (typeof value === "undefined" || value === null || value === "") {
    return true;
  }
  return /^[0-9 ]+$/.test(value);
};

export default {
  created() {
    this.$store.estadoWifi = false;
  },
  mounted(){
  },
  data() {
    return {
      form: {
        email: "",
        documento: "",
        documento2: "",
        aceptarTerminos: null,
        IdTipoDocumento: 1,
        
      },
      alert: false,
      tiposDocumento: [
        { idTiposDocumento: 1, descripcion: "C.C." },
        { idTiposDocumento: 3, descripcion: "C.E." },
        { idTiposDocumento: 4, descripcion: "Pasaporte." },
      ],
      imagen:
        "https://clientes.lacentral.com.co/services/facturas/bannerAccount.jpg",
    };
  },
  methods: {
    registrar() {
      let documentoRegistro = ""

      if(this.form.IdTipoDocumento != 1){
        documentoRegistro = this.form.documento2
        this.form.documento = "0"
      }else if (this.form.IdTipoDocumento == 1){
        documentoRegistro = this.form.documento
        this.form.documento2 = "0"
      }
      if (!this.aceptarTerminos) {
        this.$v.form.$invalid;
        this.aceptarTerminos = null;
      }
      if (this.$v.form.$error) return;

      const registro = {
        email: this.form.email,
        documento: this.form.documento,
        idTipoDocumento: this.form.IdTipoDocumento,
      };
     
      this.$store.dispatch("registrarUsuario", registro);
    },
  },
  
  validations: {
    form: {
      email: {
        required,
        email,
      },
      documento: {
        required,
      },
      IdTipoDocumento: {
        minValue: minValue(1),
      },
      aceptarTerminos: { required, sameAs: sameAs(() => true) },
    },
  },
};
</script>